(() => {
  if (window.fdLaunchApprovedReady) return;
  window.fdLaunchApprovedReady = true;
  let scrollFrame = 0;
  let scrollVersion = 0;
  const cancelScroll = () => {
    scrollVersion += 1;
    cancelAnimationFrame(scrollFrame);
    scrollFrame = 0;
  };
  const glideTo = (target) => {
    cancelScroll();
    const destination = Math.max(0, Math.min(target, document.documentElement.scrollHeight - window.innerHeight));
    const start = window.scrollY;
    const distance = destination - start;
    if (Math.abs(distance) < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo({top: destination, behavior: 'instant'});
      return;
    }
    const duration = Math.min(1000, Math.max(700, 600 + Math.abs(distance) * 0.35));
    const began = performance.now();
    const step = (now) => {
      const progress = Math.min(1, (now - began) / duration);
      const eased = progress * progress * progress * (progress * (progress * 6 - 15) + 10);
      window.scrollTo({top: start + distance * eased, behavior: 'instant'});
      scrollFrame = progress < 1 ? requestAnimationFrame(step) : 0;
    };
    scrollFrame = requestAnimationFrame(step);
  };
  const badgeSeenKey = 'fd-model-004-new-seen';
  const dismiss004Badge = () => {
    document.documentElement.classList.add('fd-model-004-seen');
    try { sessionStorage.setItem(badgeSeenKey, '1'); } catch (_) {}
  };
  try {
    if (sessionStorage.getItem(badgeSeenKey) === '1') dismiss004Badge();
  } catch (_) {}
  const initHero = () => {
    const video = document.querySelector('#fd-launch-hero');
    if (!video || video.dataset.fdClickReady) return;
    video.dataset.fdClickReady = 'true';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'fd-hero-toggle';
    const draw = (state) => {
      button.dataset.state = state;
      const playing = state === 'playing';
      button.setAttribute('aria-label', playing ? 'Pause hero video' : 'Play hero video');
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        (state === 'initial' ? '<path d="M7 4v16l14-8z"/>' : '<path d="M6 4h4v16H6zm8 0h4v16h-4z"/>') + '</svg>';
    };
    draw('initial');
    button.addEventListener('click', () => {
      if (video.paused) {
        video.dataset.fdRequested = 'true';
        if (!video.getAttribute('src')) video.src = video.dataset.fdDesktop;
        video.play().catch(() => { video.dataset.fdRequested = 'false'; draw('initial'); });
      } else {
        video.dataset.fdRequested = 'false';
        video.pause();
      }
    });
    video.addEventListener('play', () => draw('playing'));
    video.addEventListener('pause', () => { video.dataset.fdRequested = 'false'; draw(video.currentTime > 0 ? 'paused' : 'initial'); });
    video.addEventListener('ended', () => {
      video.dataset.fdRequested = 'false';
      video.currentTime = 0;
      draw('initial');
    });
    video.closest('.product-banner').append(button);
  };
  const apply = () => {
    initHero();
    const banner = document.querySelector('.header__preorder-banner');
    if (banner && banner.textContent !== 'NEXT BATCH OPEN · ORDER YOUR DRIFTER') banner.textContent = 'NEXT BATCH OPEN · ORDER YOUR DRIFTER';
    const shipping = document.querySelector('#free-ship-line');
    const domestic = !shipping || shipping.dataset.fdCountry === 'US';
    if (shipping && !document.querySelector('#fd-launch-processing')) {
      if (domestic) shipping.innerHTML = '<span class="product-info__shipping-dot"></span>Free U.S. shipping on orders $22+';
      const note = document.createElement('aside');
      note.id = 'fd-launch-processing';
      note.setAttribute('aria-label', 'Delivery estimate');
      note.textContent = domestic ? 'Estimated delivery: 7\u201311 days' : 'Delivery times vary by destination.';
      shipping.after(note);
    }
    const safety = document.querySelector('.fd-product-safety');
    const processing = document.querySelector('#fd-launch-processing');
    if (shipping && safety) {
      let home = document.querySelector('#fd-shipping-home');
      if (!home) {
        home = document.createElement('span');
        home.id = 'fd-shipping-home';
        home.hidden = true;
        shipping.before(home);
      }
      const picker = document.querySelector('.fd-model-picker');
      const mobile = window.matchMedia('(max-width:768px)').matches;
      if (mobile && picker && picker.previousElementSibling !== processing) {
        picker.before(shipping);
        shipping.after(processing);
      } else if (!mobile && home.nextElementSibling !== shipping) {
        home.after(shipping);
        shipping.after(processing);
      }
      if (picker && picker.nextElementSibling !== safety) picker.after(safety);
    }
    const foot = document.querySelector('#gb-bar .gb-bar__foot');
    if (foot && !document.querySelector('#fd-launch-cart-note')) {
      const note = document.createElement('div');
      note.id = 'fd-launch-cart-note';
      note.textContent = domestic ? 'Next batch · Estimated to deliver in 7-11 days' : 'Next batch · International delivery times vary by destination';
      foot.before(note);
    }

  };
  const init = () => {
    apply();
    window.matchMedia('(max-width:768px)').addEventListener('change', apply);
    const observer = new MutationObserver(apply);
    observer.observe(document.body, {childList: true, subtree: true});
    ['wheel', 'touchstart', 'pointerdown'].forEach(type => window.addEventListener(type, cancelScroll, {passive: true}));
    window.addEventListener('keydown', cancelScroll);
    document.addEventListener('click', event => {
      const modelButton = event.target.closest('button[data-fd-model="003"], button[data-fd-model="004"], button[data-fd-model="ghost-rider"]');
      if (modelButton) {
        if (modelButton.dataset.fdModel === '004') dismiss004Badge();
        if (event.isTrusted) {
          cancelScroll();
          const requestVersion = scrollVersion;
          requestAnimationFrame(() => requestAnimationFrame(() => {
          if (requestVersion !== scrollVersion) return;
          const isGhost = modelButton.dataset.fdModel === 'ghost-rider';
          const destination = isGhost ? document.querySelector('#fd-ghost-rider') : modelButton.closest('.fd-model-picker');
          if (!destination) return;
          const target = Math.max(0, window.scrollY + destination.getBoundingClientRect().top - (isGhost ? 20 : 40));
          glideTo(target);
        }));
        }
      }
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
